/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Form from "../../../shared/forms/Form";
import Field from "../../../shared/forms/Field";
import FormTextArea from "../../../shared/forms/FormFields/FormTextArea";
import FormDropDown from "../../../shared/forms/FormFields/FormDropDown";
import FormInputNumber from "../../../shared/forms/FormFields/FormInputNumber";
import FieldCheckBox from "../../../shared/controls/fieldCheckBox";
import ButtonIcon from "../../../shared/controls/ButtonIcon";
import PrioridadTemplate from "./PrioridadTemplate";
import ExGrid from "../../../shared/Grid/ExGrid";
import ExColumn from "../../../shared/Grid/ExColumn";
import { RadioButton } from "primereact/radiobutton";
import { TabPanel, TabView } from "primereact/tabview";
import UseApiAlmacen from "../../../api/taller/useApiAlmacen";
import constantes from "../../../operaciones/constantes";
import FormClipboardImage from "../../../shared/forms/FormFields/FormClipboardImage";

const GeneralRequisicion = ({
  value,
  departamentoId,
  unidadId,
  estatusId,
  onChange,
  onValidate,
  puedeEditar,
  gestorGuardadoId,
  errors,
}) => {
  const apiAlmacen = UseApiAlmacen();
  const [ordenesTrabajo, setOrdenesTrabajo] = useState([]);
  const [otsSeleccionadas, setOtsSeleccionadas] = useState(new Set());
  const [otSeleccionadaId, setOtSeleccionadaId] = useState(null);

  console.log(value)
  // ✅ helper: agrega p-invalid si existe error para el field
  const invalidClass = (field, rp) =>
    `${rp?.className ?? ""} ${errors?.[field] ? "p-invalid" : ""}`.trim();

  const validarLocal = (vals) => {
    const errs = {};

    const cantidad = Number(vals?.cantidad ?? 0);
    if (!cantidad || cantidad <= 0) {
      errs.cantidad = "La cantidad es obligatoria y debe ser mayor a 0.";
    }

    const ev = vals?.evidencia;
    const evidenciaVacia =
      ev == null ||
      ev === "" ||
      (Array.isArray(ev) && ev.length === 0) ||
      (typeof ev === "object" &&
        !Array.isArray(ev) &&
        !ev.base64 &&
        !ev.url &&
        !ev.file);

    if (evidenciaVacia) {
      errs.evidencia = "La evidencia es obligatoria.";
    }

    const externos =
      typeof onValidate === "function" ? onValidate(vals) ?? {} : {};
    return { ...externos, ...errs };
  };

  const toggleSeleccion = (otId) => {
    setOtsSeleccionadas((prev) => {
      const next = new Set(prev);
      next.has(otId) ? next.delete(otId) : next.add(otId);

      const ids = Array.from(next);

      onChange?.({
        ...value,
        requisicionDetalle: ids.map((id) => ({ ordenTrabajoId: id })),
      });

      return next;
    });
  };

  async function obtenerOrdenes(uId) {
    if (!uId) return;
    setOtsSeleccionadas(new Set());

    const ordenes = await apiAlmacen.filtrar(uId);
    const lista = Array.isArray(ordenes) ? ordenes : [];
    setOrdenesTrabajo(lista);

    const existentes = value?.requisicionDetalle ?? [];
    if (existentes.length > 0) {
      const idsSeleccionadas = new Set(
        existentes.map((x) => x.ordenTrabajoId ?? x.numeroOrden)
      );
      const idsValidos = new Set(
        lista
          .map((o) => o.id ?? o.ordenDeTrabajo)
          .filter((id) => idsSeleccionadas.has(id))
      );
      setOtsSeleccionadas(idsValidos);
    }
  }

  useEffect(() => {
    if (!value) return;
     const otId = value?.ordenTrabajoId ?? value?.ordenesTrabajo ?? null;
    if (otSeleccionadaId == null && otId != null) {
      setOtSeleccionadaId(otId);
    }
    const deptoDefault = departamentoId ?? null;
    const unidadDefault = unidadId ?? null;
    const estatusIdDefault = estatusId ?? null;
    if (!deptoDefault && !unidadDefault && !estatusIdDefault) return;

    const necesitaDepto = !value.departamentoId && deptoDefault;
    const necesitaUnidad = !value.unidadId && unidadDefault;
    const necesitaEstatus = !value.estatusId && estatusIdDefault;

    if (!necesitaDepto && !necesitaUnidad && !necesitaEstatus) return;

    onChange?.({
      ...value,
      ...(necesitaDepto ? { departamentoId: deptoDefault } : {}),
      ...(necesitaUnidad ? { unidadId: unidadDefault } : {}),
      ...(necesitaEstatus ? { estatusId: estatusIdDefault } : {}),
    });

    if (necesitaUnidad) obtenerOrdenes(unidadDefault);
    
  }, [departamentoId, unidadId, estatusId, value?.id]);
useEffect(() => {
  if (!value?.unidadId) return;
  obtenerOrdenes(value.unidadId);
}, [value?.unidadId]);

  const formDisabled =
    (value?.id > 0 && !puedeEditar) ||
    value?.estatusId === constantes.estatusRequisiciones.cerrada;

  return (
    <>
      <Form
        columns={4}
        values={value}
        onChange={onChange}
        onValidate={validarLocal}
        formDisabled={formDisabled}
      >
        <Field
          label={"Prioridad"}
          field={"prioridadId"}
          source="general/PrioridadRequisiciones"
          itemTemplate={PrioridadTemplate}
          required
          cols={2}
          render={(rp) => (
            <FormDropDown {...rp} className={invalidClass("prioridadId", rp)} />
          )}
        />

        <Field
          label={"Tipo"}
          field={"tipoId"}
          source={"tipoRequisiciones"}
          required
          cols={1}
          render={(rp) => (
            <FormDropDown {...rp} className={invalidClass("tipoId", rp)} />
          )}
        />

        <Field
          label={"Cantidad"}
          field={"cantidad"}
          cols={1}
          required
          render={(rp) => (
            <FormInputNumber {...rp} className={invalidClass("cantidad", rp)} />
          )}
        />

        <Field
          label={"Departamento"}
          field={"departamentoId"}
          source={"departamentos"}
          required
          cols={2}
          render={(rp) => (
            <FormDropDown
              {...rp}
              className={invalidClass("departamentoId", rp)}
            />
          )}
        />

        <Field
          label={"Almacen Destino"}
          field={"almacenId"}
          source={"empresas"}
          required
          cols={2}
          render={(rp) => (
            <FormDropDown {...rp} className={invalidClass("almacenId", rp)} />
          )}
        />

        <Field
          label="No Económico"
          field="unidadId"
          source="unidades"
          params={{ todasLasEmpresas: true }}
          cols={2}
          required={!value?.almacenSeguridad}
          render={(rp) => (
            <FormDropDown
              {...rp}
              className={invalidClass("unidadId", rp)}
              source="unidades"
              params={{ todasLasEmpresas: true }}
              onChange={(e) => {
                rp?.onChange?.(e);
                const uId = e?.value ?? e?.target?.value ?? e;
                if (uId) obtenerOrdenes(uId);
              }}
            />
          )}
        />

        <Field
          label={"Almacen de Seguridad"}
          field={"almacenSeguridad"}
          render={FieldCheckBox}
          cols={2}
        />

        <Field
          label={"Estatus"}
          field={"estatusId"}
          source={"estatusRequisiciones"}
          required
          cols={2}
          render={(rp) => (
            <FormDropDown {...rp} className={invalidClass("estatusId", rp)} />
          )}
        />
        <Field
          label="Evidencia"
          field="evidencia"
          cols={2}
          required
          render={(rp) => (
            <div
              className={
                errors?.evidencia
                  ? "p-invalid evidencia-wrapper"
                  : "evidencia-wrapper"
              }
            >
              <FormClipboardImage {...rp} />
            </div>
          )}
        />

        <Field
          label={"Requerimiento"}
          field={"comentarios"}
          cols={4}
          render={(rp) => (
            <FormTextArea
              {...rp}
              rows={8}
              required
              maxLength={140}
              className={invalidClass("comentarios", rp)}
              error={errors?.comentarios}
            />
          )}
        />
      </Form>

      <TabView>
        <TabPanel header="Órdenes de trabajo">
          <ExGrid data={ordenesTrabajo} responsiveLayout="scroll" scrollable>
            <ExColumn
              title=""
              width="6%"
              cellRenderer={({ row }) => {
                const ordenesTrabajoIds = Array.isArray(value?.ordenesTrabajo)
                  ? value.ordenesTrabajo
                  : value?.ordenesTrabajo
                    ? [value.ordenesTrabajo]
                    : [];

                const id = row?.id ?? row?.ordenDeTrabajo;

                const checked =
                  otsSeleccionadas.has(id) ||
                  ordenesTrabajoIds.includes(id);
                return (
                  <div className="p-field-radiobutton main-item-container">
                    <RadioButton
                      inputId={`ot-${id}`}
                      name={`ot-${id}`}
                      value={id}
                      checked={checked}
                      onChange={() => toggleSeleccion(id)}
                    />
                    <label htmlFor={`ot-${id}`} />
                  </div>
                );
              }}
            />
            <ExColumn title="N°" field="ordenDeTrabajo" />
            <ExColumn title="Tipo" field="tipoServicio" />
            <ExColumn title="Descripción" field="descripcion" />
            <ExColumn
              title={<ButtonIcon title="" iconName="FcEmptyBattery" />}
            />
          </ExGrid>
        </TabPanel>
      </TabView>
    </>
  );
};

export default GeneralRequisicion;
